import { FunctionOfHealthcare, FunctionOfHealthcareQuery } from '@dreryk/egabinet-healthcare-provider-frontend-api';

import { performCqrsQuerySearch } from '@dreryk/command-query-react-common';
import {
   AutosuggestItemRenderer,
   AutosuggestLabelExtractor,
   AutosuggestSearchCreator,
   KeyExtractorRendererKeyExtractor,
} from '@dreryk/react-components';
import { TextPattern } from '@dreryk/watermelon';

export const functionOfHealthcareItemRenderer: AutosuggestItemRenderer<FunctionOfHealthcare> = (item) => (
   <>
      {item.code} {item.name}
   </>
);
export const functionOfHealthcareLabelExtractor: AutosuggestLabelExtractor<FunctionOfHealthcare> = (item) =>
   `${item.code} ${item.name}`;
export const functionOfHealthcareKeyExtractor: KeyExtractorRendererKeyExtractor<FunctionOfHealthcare> = (item) =>
   item.code;

export const functionOfHealthcareSearchCreator: AutosuggestSearchCreator<FunctionOfHealthcare> = (searchText) => {
   return async () =>
      performCqrsQuerySearch<FunctionOfHealthcare>(() => {
         const query = new FunctionOfHealthcareQuery();
         if (searchText) {
            query.nameOrCode = TextPattern.anywhereIgnoreCase(searchText);
         }
         return query;
      });
};
